import logger from "@airhelp/node-logger";
import type { LanguageCode } from "config/languages";
import { useServerSideStoryblokPages } from "contexts/DataContext/hooks";
import getDomainFromLanguage from "utils/getDomainFromLanguage";
import { getParentLanguage } from "utils/localeUtils";
import { storyblokPages } from "./config";
import type { PageName } from "./types";

const getStoryblokPageUrl = (language: LanguageCode, pageName: PageName): string => {
  const pageId = storyblokPages[pageName];
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const pages = useServerSideStoryblokPages();
  const domain = getDomainFromLanguage(language);

  const page = pages[pageId];
  const parentLanguage = getParentLanguage(language);
  const parentLanguageDomain = getDomainFromLanguage(parentLanguage);

  const { [language]: languageUrl, [parentLanguage]: parentLanguageUrl, en: englishUrl } = page;
  const englishLanguageDomain = getDomainFromLanguage("en");

  if (languageUrl) return `${domain}${languageUrl}/`;
  if (parentLanguageUrl) return `${parentLanguageDomain}${parentLanguageUrl}/`;
  logger.warn(`Url for ${pageName} in "${language}" was not found.`);

  if (englishUrl) return `${englishLanguageDomain}${englishUrl}/`;

  logger.error(`Url for ${pageName} in was not found.`);

  return "/";
};

export default getStoryblokPageUrl;
